/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  LicenseIn,
  LicenseOut,
  LicenseSummaryOut,
  ListLicensesParams,
  PaginatedLicenseOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listLicensesResponse200 = {
  data: PaginatedLicenseOut
  status: 200
}

export type listLicensesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listLicensesResponseSuccess = (listLicensesResponse200) & {
  headers: Headers;
};
export type listLicensesResponseError = (listLicensesResponse422) & {
  headers: Headers;
};

export type listLicensesResponse = (listLicensesResponseSuccess | listLicensesResponseError)

export const getListLicensesUrl = (params?: ListLicensesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/licenses?${stringifiedParams}` : `/api/licenses`
}

/**
 * @summary List Licenses
 */
export const listLicenses = async (params?: ListLicensesParams, options?: Parameters<typeof apiFetch>[1]): Promise<listLicensesResponse> => {

  return apiFetch<listLicensesResponse>(getListLicensesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLicensesQueryKey = (params?: ListLicensesParams,) => {
    return [
    `/api/licenses`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLicensesQueryOptions = <TData = Awaited<ReturnType<typeof listLicenses>>, TError = HTTPValidationError>(params?: ListLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLicenses>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLicensesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLicenses>>> = ({ signal }) => listLicenses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLicenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLicensesQueryResult = NonNullable<Awaited<ReturnType<typeof listLicenses>>>
export type ListLicensesQueryError = HTTPValidationError


export function useListLicenses<TData = Awaited<ReturnType<typeof listLicenses>>, TError = HTTPValidationError>(
 params: undefined |  ListLicensesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLicenses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLicenses>>,
          TError,
          Awaited<ReturnType<typeof listLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLicenses<TData = Awaited<ReturnType<typeof listLicenses>>, TError = HTTPValidationError>(
 params?: ListLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLicenses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLicenses>>,
          TError,
          Awaited<ReturnType<typeof listLicenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLicenses<TData = Awaited<ReturnType<typeof listLicenses>>, TError = HTTPValidationError>(
 params?: ListLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLicenses>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Licenses
 */

export function useListLicenses<TData = Awaited<ReturnType<typeof listLicenses>>, TError = HTTPValidationError>(
 params?: ListLicensesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLicenses>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLicensesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createLicenseResponse201 = {
  data: LicenseOut
  status: 201
}

export type createLicenseResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createLicenseResponseSuccess = (createLicenseResponse201) & {
  headers: Headers;
};
export type createLicenseResponseError = (createLicenseResponse422) & {
  headers: Headers;
};

export type createLicenseResponse = (createLicenseResponseSuccess | createLicenseResponseError)

export const getCreateLicenseUrl = () => {




  return `/api/licenses`
}

/**
 * @summary Create License
 */
export const createLicense = async (licenseIn: LicenseIn, options?: Parameters<typeof apiFetch>[1]): Promise<createLicenseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createLicenseResponse>(getCreateLicenseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(licenseIn)
  }
);}





export const getCreateLicenseMutationKey = () => ['createLicense'] as const;

export const getCreateLicenseMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLicense>>, TError,CreateLicenseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLicense>>, TError,CreateLicenseMutationVariables, TContext> => {

const mutationKey = getCreateLicenseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLicense>>, CreateLicenseMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createLicense(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof createLicense>>>
    export type CreateLicenseMutationBody = LicenseIn
    export type CreateLicenseMutationError = HTTPValidationError
    export type CreateLicenseMutationVariables = {data: LicenseIn}

    /**
 * @summary Create License
 */
export const useCreateLicense = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLicense>>, TError,CreateLicenseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLicense>>,
        TError,
        CreateLicenseMutationVariables,
        TContext
      > => {
      return useMutation(getCreateLicenseMutationOptions(options), queryClient);
    }
    export type getLicenseSummaryResponse200 = {
  data: LicenseSummaryOut
  status: 200
}

export type getLicenseSummaryResponseSuccess = (getLicenseSummaryResponse200) & {
  headers: Headers;
};
;

export type getLicenseSummaryResponse = (getLicenseSummaryResponseSuccess)

export const getGetLicenseSummaryUrl = () => {




  return `/api/licenses/summary`
}

/**
 * @summary Get License Summary
 */
export const getLicenseSummary = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getLicenseSummaryResponse> => {

  return apiFetch<getLicenseSummaryResponse>(getGetLicenseSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLicenseSummaryQueryKey = () => {
    return [
    `/api/licenses/summary`
    ] as const;
    }


export const getGetLicenseSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getLicenseSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLicenseSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLicenseSummary>>> = ({ signal }) => getLicenseSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLicenseSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLicenseSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getLicenseSummary>>>
export type GetLicenseSummaryQueryError = unknown


export function useGetLicenseSummary<TData = Awaited<ReturnType<typeof getLicenseSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLicenseSummary>>,
          TError,
          Awaited<ReturnType<typeof getLicenseSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLicenseSummary<TData = Awaited<ReturnType<typeof getLicenseSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLicenseSummary>>,
          TError,
          Awaited<ReturnType<typeof getLicenseSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLicenseSummary<TData = Awaited<ReturnType<typeof getLicenseSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get License Summary
 */

export function useGetLicenseSummary<TData = Awaited<ReturnType<typeof getLicenseSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLicenseSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLicenseSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updateLicenseResponse200 = {
  data: LicenseOut
  status: 200
}

export type updateLicenseResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateLicenseResponseSuccess = (updateLicenseResponse200) & {
  headers: Headers;
};
export type updateLicenseResponseError = (updateLicenseResponse422) & {
  headers: Headers;
};

export type updateLicenseResponse = (updateLicenseResponseSuccess | updateLicenseResponseError)

export const getUpdateLicenseUrl = (licenseId: number,) => {




  return `/api/licenses/${licenseId}`
}

/**
 * @summary Update License
 */
export const updateLicense = async (licenseId: number,
    licenseIn: LicenseIn, options?: Parameters<typeof apiFetch>[1]): Promise<updateLicenseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updateLicenseResponse>(getUpdateLicenseUrl(licenseId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(licenseIn)
  }
);}





export const getUpdateLicenseMutationKey = () => ['updateLicense'] as const;

export const getUpdateLicenseMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLicense>>, TError,UpdateLicenseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLicense>>, TError,UpdateLicenseMutationVariables, TContext> => {

const mutationKey = getUpdateLicenseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLicense>>, UpdateLicenseMutationVariables> = (props) => {
          const {licenseId,data} = props ?? {};

          return  updateLicense(licenseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof updateLicense>>>
    export type UpdateLicenseMutationBody = LicenseIn
    export type UpdateLicenseMutationError = HTTPValidationError
    export type UpdateLicenseMutationVariables = {licenseId: number;data: LicenseIn}

    /**
 * @summary Update License
 */
export const useUpdateLicense = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLicense>>, TError,UpdateLicenseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLicense>>,
        TError,
        UpdateLicenseMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateLicenseMutationOptions(options), queryClient);
    }
    export type deleteLicenseResponse204 = {
  data: void
  status: 204
}

export type deleteLicenseResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteLicenseResponseSuccess = (deleteLicenseResponse204) & {
  headers: Headers;
};
export type deleteLicenseResponseError = (deleteLicenseResponse422) & {
  headers: Headers;
};

export type deleteLicenseResponse = (deleteLicenseResponseSuccess | deleteLicenseResponseError)

export const getDeleteLicenseUrl = (licenseId: number,) => {




  return `/api/licenses/${licenseId}`
}

/**
 * @summary Delete License
 */
export const deleteLicense = async (licenseId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteLicenseResponse> => {

  return apiFetch<deleteLicenseResponse>(getDeleteLicenseUrl(licenseId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteLicenseMutationKey = () => ['deleteLicense'] as const;

export const getDeleteLicenseMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLicense>>, TError,DeleteLicenseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLicense>>, TError,DeleteLicenseMutationVariables, TContext> => {

const mutationKey = getDeleteLicenseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLicense>>, DeleteLicenseMutationVariables> = (props) => {
          const {licenseId} = props ?? {};

          return  deleteLicense(licenseId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLicenseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLicense>>>

    export type DeleteLicenseMutationError = HTTPValidationError
    export type DeleteLicenseMutationVariables = {licenseId: number}

    /**
 * @summary Delete License
 */
export const useDeleteLicense = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLicense>>, TError,DeleteLicenseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLicense>>,
        TError,
        DeleteLicenseMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteLicenseMutationOptions(options), queryClient);
    }
